import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  getBenchmarkingData,
  getBenchmarkingValue,
  getClubValue,
} from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import MultiSelectDropdown from '../MultiSelectComponent/MultiSelectPrimary/selectDropDownComponent';
import { SingleOption } from '../licenseAnalyticsSupport/typeInterfaces';
// @ts-ignore: allow importing CSS file without type declarations
import './GraphComponent.css';
import { getBenchmarkingFirstLevelOptions } from '../licenseAnalyticsSupport/filtersOptions';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import benchmarkInfoEN from '../../../assets/images/english.png';
import benchmarkInfoJP from '../../../assets/images/japanese.png';
import { LanguageCode } from '../../../api/types';
import { useTranslation } from 'react-i18next';
import BoxPlot from '../D3/BoxPlot';
import { styled } from '@mui/material/styles';
import { setBenchmarkingValue } from '../../../redux/reducers/licenceAnalytics';

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const BenchMarkingComponent: React.FC<any> = ({ page, departments }) => {
  const [t] = useTranslation();
  const clubValue = useSelector(getClubValue);
  const [diagram, setDiagram] = useState(benchmarkInfoEN);
  const benchmarkingOptions = getBenchmarkingFirstLevelOptions(page);
  const benchmarkingValue: SingleOption | undefined = useSelector(getBenchmarkingValue);
  let [seriesData, clubData] = useSelector((state:any) => getBenchmarkingData(state, departments));

  const dispatch = useDispatch();

  const onBenchmarkingChange = (newValue: SingleOption | undefined) => {
    dispatch(setBenchmarkingValue({ newValue }));
  };
  seriesData = seriesData.map((data:any) => {
    return { x: t(data.x), y: data.y, z: data.z };
  });

  useEffect(() => {
    if (localStorage.getItem('lang') === LanguageCode.Japanese) {
      setDiagram(benchmarkInfoJP);
    } else {
      setDiagram(benchmarkInfoEN);
    }
  }, [localStorage]);

  return (
    <>
      <div className="chart" id="chart">
        <div className="title">
          <div style={{ display: 'flex' }}>
            {t('BENCHMARKING')} <br />
            <HtmlTooltip
              title={
                <React.Fragment>
                  <img src={diagram} style={{ width: '100%' }} />
                </React.Fragment>
              }
            >
              <HelpIcon fontSize="small" style={{ padding: '3px' }} color="primary" />
            </HtmlTooltip>
          </div>

          <h4 style={{ fontWeight: '100' }}>{t('BENCHMARKING_LABEL')}</h4>
        </div>
        <div className="filtersWrapper">
          <MultiSelectDropdown
            options={benchmarkingOptions}
            value={benchmarkingValue}
            onChange={onBenchmarkingChange}
            width="100%"
            rootCss={{ width: '100%', marginRight: '20px' }}
          />
        </div>
        <BoxPlot data={seriesData} benchmarkingValue={benchmarkingValue} />
      </div>
    </>
  );
};

export default BenchMarkingComponent;
